import React from 'react';
import { decodeForDisplay } from '../helpers/functions'


class AboutDescription extends React.Component {

    render(){
        return (
            <div className="about-description" >
                {decodeForDisplay(this.props.text)}
            </div>
        )
    }
}

export default AboutDescription;


// WEBPACK FOOTER //
// ./src/components/AboutDescription.js